import { getCookie } from 'src/helpers'
import { useConfigCat } from 'src/hooks'

export const useTutorialEnabled = () => {
  const { featureFlags } = useConfigCat()
  const hasOnboardingTutorialCookie = getCookie('onboarding_tutorial')
  const isOnboardingTutorialFlagOn = featureFlags.onboarding_tutorial
  return isOnboardingTutorialFlagOn && !hasOnboardingTutorialCookie
}
